var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14286 9.46571V10.9586C6.49637 10.73 5.80448 10.6599 5.12529 10.7541C4.44609 10.8484 3.79943 11.1042 3.23959 11.5001C2.67976 11.8961 2.2231 12.4206 1.90797 13.0296C1.59284 13.6386 1.42844 14.3143 1.42857 15L1.84612e-07 14.9993C-0.00022151 14.1271 0.199229 13.2664 0.58307 12.4831C0.966911 11.6999 1.52496 11.015 2.21444 10.4807C2.90393 9.94653 3.70655 9.57724 4.56082 9.40118C5.41509 9.22511 6.29833 9.24766 7.14286 9.46571ZM5.71429 8.57143C3.34643 8.57143 1.42857 6.65357 1.42857 4.28571C1.42857 1.91786 3.34643 0 5.71429 0C8.08214 0 10 1.91786 10 4.28571C10 6.65357 8.08214 8.57143 5.71429 8.57143ZM5.71429 7.14286C7.29286 7.14286 8.57143 5.86429 8.57143 4.28571C8.57143 2.70714 7.29286 1.42857 5.71429 1.42857C4.13571 1.42857 2.85714 2.70714 2.85714 4.28571C2.85714 5.86429 4.13571 7.14286 5.71429 7.14286ZM10 11.4286V9.28571H11.4286V11.4286H13.5714V12.8571H11.4286V15H10V12.8571H7.85714V11.4286H10Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.3ee5644c43438eec6436b61d575f2846.svg";
export { ForwardRef as ReactComponent };